import { defineComponent, computed, useAttrs, createElementBlock, openBlock, normalizeStyle, normalizeClass, renderSlot, createElementVNode, withDirectives, unref, createCommentVNode, toDisplayString, mergeProps, vShow } from "vue";
import { S as SIZES } from "./p-btn.types.js";
import { useInputClasses } from "../useInputClasses.js";
const _hoisted_1 = ["data-has-error"];
const _hoisted_2 = ["value"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "PTextarea",
    inheritAttrs: false
  },
  __name: "p-textarea",
  props: {
    modelValue: {
      type: [String, Number, null],
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    errorMsg: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "md",
      validator(value) {
        return SIZES.includes(value);
      }
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const props = __props;
    const { labelClasses, textareaClasses, errorMsgClasses } = useInputClasses(
      computed(() => ({
        required: props.required,
        errorMsg: props.errorMsg,
        size: props.size
      }))
    );
    const allAttrs = useAttrs();
    const attrs = computed(() => {
      const { class: classes, style: style2, ...rest } = allAttrs;
      return rest;
    });
    const style = computed(() => {
      return allAttrs.style;
    });
    const updateValue = (e) => {
      const target = e.target;
      emit("update:modelValue", target.value);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([{ hidden: _ctx.$attrs.hidden }, _ctx.$attrs.class]),
        "data-has-error": !!__props.errorMsg,
        style: normalizeStyle(style.value)
      }, [
        renderSlot(_ctx.$slots, "label", {
          label: __props.label,
          labelClasses: unref(labelClasses)
        }, () => [
          __props.label ? (openBlock(), createElementBlock("label", {
            key: 0,
            class: normalizeClass(unref(labelClasses))
          }, toDisplayString(__props.label), 3)) : createCommentVNode("", true)
        ]),
        createElementVNode("textarea", mergeProps({ value: __props.modelValue }, attrs.value, {
          class: unref(textareaClasses),
          onInput: updateValue
        }), " ", 16, _hoisted_2),
        withDirectives(createElementVNode("div", {
          class: normalizeClass(unref(errorMsgClasses))
        }, toDisplayString(__props.errorMsg), 3), [
          [vShow, __props.errorMsg]
        ])
      ], 14, _hoisted_1);
    };
  }
});
export {
  _sfc_main as _
};
